module.exports = __webpack_public_path__ + "img/icon-groceries.2109058d.svg";